import React, { Component } from 'react';
import GeoDialog            from './Banner/containers/GeoDialogContainer';
import GeoToggle            from './../containers/Banner/GeoToggleContainer';
import Logo                 from './Banner/Logo';

class Banner extends Component
{
    render() {
        return (
            <div id="banner" style={{ background: this.props.theme.banner.background }}>
                <Logo logo={ this.props.logo }  />
                <div className="geo-toggle">
                    <GeoToggle />
                </div>
                <GeoDialog />
            </div>
        );
    }
}

export default Banner;


// WEBPACK FOOTER //
// ./src/components/Banner.js